import { HttpMethod } from '@teqplay/api'

import { requestBuilder } from '../builder'

export type TUser = {
  _id: string
  email: string
  phoneNumber: string
  enabled: boolean
  languagePreference?: 'EN' | 'PT'
}

export type TUserError = {
  timestamp: string
  status: number
  error: string
  message: string
  path: string
}

// GET /v1/user
export type TGetUserInput = void
export type TGetUserOutput = TUser

const get = requestBuilder.type<TGetUserInput, TGetUserOutput>().request(() => ({
  path: `/v1/user`,
  method: HttpMethod.GET
}))

// PATCH /v1/user
export type TPatchUserInput = {
  phoneNumber?: string
  language?: 'EN' | 'PT' | null
}
export type TPatchUserOutput = Record<string, never>

const patch = requestBuilder.type<TPatchUserInput, TPatchUserOutput>().request(({ input }) => ({
  path: `/v1/user`,
  method: HttpMethod.PATCH,
  init: {
    body: JSON.stringify(input)
  }
}))

const user = { get, patch }
export default user
